export interface PostFetcherOptions {
    nonce?: string;
    credentials?: RequestCredentials;
    headers?: Record<string, string>;
    method?: 'POST' | 'PUT' | 'DELETE';
}

export async function postFetcher<T = any>(
    route: string,
    payload: Record<string, unknown> | FormData | string,
    options: PostFetcherOptions = {},
): Promise<T> {
    const headers: Record<string, string> = {
        ...(options.headers ?? {}),
    };

    if (!(payload instanceof FormData) && !headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    if (options.nonce) {
        headers['X-WP-Nonce'] = options.nonce;
    }

    const body = typeof payload === 'string' || payload instanceof FormData
        ? payload
        : JSON.stringify(payload);

    const response = await fetch(route, {
        method: options.method ?? 'POST',
        credentials: options.credentials ?? 'include',
        headers,
        body,
    });

    const responseText = await response.text();

    // Try to parse JSON body. If parsing fails, remember that and keep raw text.
    let parsedBody: any = null;
    let parseSucceeded = false;
    try {
        parsedBody = responseText ? JSON.parse(responseText) : {};
        parseSucceeded = true;
    } catch {
        parsedBody = null;
        parseSucceeded = false;
    }

    // If response status is not OK, try to return the parsed JSON error (if any),
    // otherwise return a network-style error similar to fetchers.js behavior.
    if (!response.ok) {
        if (parseSucceeded && parsedBody !== null) {
            const nestedMessage = parsedBody?.data?.message ?? parsedBody?.message;
            if (nestedMessage) throw new Error(nestedMessage);
            throw parsedBody;
        }
        throw { message: 'خطای شبکه', status: response.status };
    }

    // For OK responses, fall back to previous behavior: if body wasn't JSON,
    // expose the raw text as the message.
    const responseBody = parseSucceeded ? parsedBody : { message: responseText };

    if (responseBody?.success !== true) {
        const nestedMessage = responseBody?.data?.message ?? responseBody?.message;
        throw new Error(nestedMessage ?? 'درخواست با خطا مواجه شد.');
    }

    return responseBody as T;
}
